import React, { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, Sparkles } from "lucide-react";
import { CONSTANTS } from "../data";

interface DiscoveryNotificationProps {
  discovery: {
    recipeName: string;
    timestamp: number;
  } | null;
  onComplete: () => void;
}

const DiscoveryNotification: React.FC<DiscoveryNotificationProps> = ({
  discovery,
  onComplete,
}) => {
  useEffect(() => {
    if (discovery) {
      const timer = setTimeout(onComplete, CONSTANTS.NOTIFICATION_DURATION);
      return () => clearTimeout(timer);
    }
  }, [discovery, onComplete]);

  return (
    <AnimatePresence>
      {discovery && (
        <motion.div
          initial={{ opacity: 0, y: -20, scale: 0.95 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 20, scale: 0.95 }}
          transition={{ ease: "easeOut", duration: 0.3 }}
          className="fixed top-24 right-6 bg-surface text-text-primary font-semibold px-6 py-4 rounded-lg shadow-lg z-50 border border-border-color flex items-center gap-4"
        >
          <div className="text-success">
            <Sparkles size={24} />
          </div>
          <div>
            <div className="text-sm text-text-secondary">New Recipe Discovered!</div>
            <div className="text-lg">{discovery.recipeName}</div>
          </div>
          <button
            onClick={onComplete}
            className="absolute top-2 right-2 text-text-secondary hover:text-text-primary transition-colors p-1 rounded-full hover:bg-bg-main"
            aria-label="Close notification"
          >
            <X size={18} />
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default DiscoveryNotification;
